/* eslint-disable react-hooks/rules-of-hooks */
'use client';

import { ICoordinate } from '@/types';
import { useState, useEffect } from 'react';

const usegeolocation = (localstoragekey = 'is-location-granted') => {
    const [shouldrequestlocation, setshouldrequestlocation] = useState(false);
    const [loading, setloading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, seterror] = useState<GeolocationPositionError>();
    const [coords, setcoords] = useState<ICoordinate>();

    const onsuccess = (location: GeolocationPosition) => {
        setloading(false);
        setSuccess(true);
        setcoords({
            lat: location.coords.latitude,
            lng: location.coords.longitude,
        });
        if (!('permissions' in navigator)) {
            localStorage.setItem(localstoragekey, JSON.stringify(true));
        }
    };

    const onerror = (error: GeolocationPositionError) => {
        setloading(false);
        seterror(error);
        setcoords(undefined);
        setSuccess(false);
        localStorage.setItem(localstoragekey, JSON.stringify(false));
    };

    useEffect(() => {
        if ('permissions' in navigator) {
            navigator.permissions
                .query({ name: 'geolocation' })
                .then(permissionstatus => {
                    if (permissionstatus.state !== 'granted') {
                        setshouldrequestlocation(true);
                    } else {
                        setSuccess(true);
                    }
                });
        } else {
            const islocationgranted = JSON.parse(
                localStorage.getItem(localstoragekey) || 'false'
            );
            if (!islocationgranted) {
                setshouldrequestlocation(true);
            } else {
                setSuccess(true);
            }
        }
    }, []);

    useEffect(() => {
        if (!('geolocation' in navigator)) {
            const geoerror = new GeolocationPositionError();
            seterror({
                ...geoerror,
                message: 'geolocation not supported',
            });
        } else if (shouldrequestlocation) {
            setloading(true);
            navigator.geolocation.getCurrentPosition(onsuccess, onerror, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 18000000,
            });
        }
    }, [shouldrequestlocation]);

    return { loading, error, coords, success };
};

export default usegeolocation;
